var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhitePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.5H1.167M11.5 20.833V10.5v10.333zm0-10.333V.167 10.5zm0 0h10.334H11.5z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMiAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjUwMDMgMTAuNDk5OEgxLjE2Njk5TTExLjUwMDMgMjAuODMzMlYxMC40OTk4VjIwLjgzMzJaTTExLjUwMDMgMTAuNDk5OFYwLjE2NjUwNFYxMC40OTk4Wk0xMS41MDAzIDEwLjQ5OThIMjEuODMzN0gxMS41MDAzWiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgWhitePlus as ReactComponent };